import React, { Fragment } from 'react';

import map from 'lodash/map';
import includes from 'lodash/includes';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const RadioTagsRenderer_ViewerVersion1 = ({ categoryId, categoryLabel, tags, selectedTagIds, onChange })=> (
  <div className="grid-section-filters-category">
    <div className="grid-section-filters-category-label">
      { categoryLabel }
    </div>

    <div className="grid-section-filters-category-tags">
      {
        map(tags, (tag)=> (
          <label
            key={tag.id}
            name={tag.id}
            htmlFor={tag.id}
          >
            <input
              id={tag.id}
              type="radio" 
              name={tag.id}
              checked={includes(selectedTagIds, tag.id)}
              onChange={()=> {
                onChange(categoryId, tag.id);
              }}
            />

            <span>{ tag.label }</span>
          </label>
        ))
      }
    </div>
  </div>
);

const RadioTagsRenderer_ViewerVersion2 = ({ categoryId, categoryLabel, tags, selectedTagIds, onChange })=> (
  <fieldset className="grid-section-filters-category">
    <legend className="grid-section-filters-category-label">
      { categoryLabel }
    </legend>

    <div className="grid-section-filters-category-tags">
      {
        map(tags, (tag)=> (
          <Fragment>
            <input
              id={tag.id}
              type="radio" 
              name={tag.id}
              checked={includes(selectedTagIds, tag.id)}
              onChange={()=> {
                onChange(categoryId, tag.id);
              }}
            />

            <label
              key={tag.id}
              name={tag.id}
              htmlFor={tag.id}
            >
              { tag.label }
            </label>
          </Fragment>
        ))
      }
    </div>
  </fieldset>
);

const RadioTagsRenderer = (props)=> (
  <SiteViewerVersionComponentSelector>
    <RadioTagsRenderer_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <RadioTagsRenderer_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default RadioTagsRenderer;
